import { render } from "./VabeneAddCategorie.vue?vue&type=template&id=450701e7&ts=true"
import script from "./VabeneAddCategorie.vue?vue&type=script&lang=ts"
export * from "./VabeneAddCategorie.vue?vue&type=script&lang=ts"

import "./VabeneAddCategorie.vue?vue&type=style&index=0&id=450701e7&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__